import { useEffect, useState } from 'react';
import { useTX } from '@transifex/react';
import log from 'logging';

type TranslationsLoader = {
  isReady: boolean;
  tx: ReturnType<typeof useTX>;
};

export const useTranslationsLoader = (language: string): TranslationsLoader => {
  const tx = useTX();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    tx.setCurrentLocale(language)
      .then(() => {
        setIsReady(true);
      })
      .catch(() => {
        log.error('Failed to load translations');
        // Fallback to default language if loading fails
        setIsReady(true);
      });
  }, [language, tx]);

  return {
    isReady,
    tx,
  };
};
